import { Button, Tag } from '@chakra-ui/react';
import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';

import { colors } from '~/packages/common-frontend/colors';
import { Typography } from '~/packages/common-frontend/components/Typography';

export const IdPill = ({
  to,
  label,
  value,
}: {
  to?: string;
  label: string;
  value: string;
}) => {
  return (
    <Tag
      backgroundColor="white"
      borderColor={colors.gray[100]}
      borderRadius="64px"
      borderWidth="1px"
      cursor={to ? 'pointer' : 'default'}
      gap="0.5rem"
      p="0.5rem 1rem"
    >
      <Typography fontWeight="bold">{label}</Typography>
      {to ? (
        <Button
          as={ReactRouterLink}
          variant="link"
          target="_blank"
          to={to}
          textDecoration="none"
          _hover={{ textDecoration: 'none' }}
        >
          <Typography
            colorScheme="blue"
            fontWeight="medium"
            variant="detail-muted"
          >
            {value}
          </Typography>
        </Button>
      ) : (
        <Typography>{value}</Typography>
      )}
    </Tag>
  );
};
